enum JOBSTATE {
  WAITING = 0,
  RUNNING = 1,
  CANCEL = 2,
  ERROR = 3,
  FINISHED = 4,
  EXPIRED = 5,
  SCHEDULED = 6
}

export class Job {
  public static STATE = JOBSTATE
  public eta: number
  public jobState: number
  public message: string
  public contentName: string
  public rate: number
  public deviceName: string
  public totalSize: number
  public transferSize: number
}
